import { Card, CardBody, Col, Row } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { TotalUsersHeading } from "../../../../utils/Constant";
import TotalUsersBody from "./TotalUsersBody";
import FollowersGrowth from "./FollowersGrowth/FollowersGrowth";

const TotalUsers = () => {
  return (
    <Col xxl="4" xl="5" md="6" className="box-col-6">
      <Row>
        <Col xl="12">
          <Card>
            <CardHeaderCommon headClass="pb-0" title={TotalUsersHeading} firstItem="Weekly" secondItem="Monthly" thirdItem="Yearly" />
            <CardBody className="py-lg-3">
              <TotalUsersBody />
            </CardBody>
          </Card>
        </Col>
        <FollowersGrowth />
      </Row>
    </Col>
  );
};

export default TotalUsers;
